__turbopack_context__.v({
  "content": "AssetLayout-module__bmOA9G__content",
  "contentPanel": "AssetLayout-module__bmOA9G__contentPanel",
  "desktopNav": "AssetLayout-module__bmOA9G__desktopNav",
  "favoritesIcon": "AssetLayout-module__bmOA9G__favoritesIcon",
  "favoritesNav": "AssetLayout-module__bmOA9G__favoritesNav",
  "favoritesNavItem": "AssetLayout-module__bmOA9G__favoritesNavItem",
  "folderTree": "AssetLayout-module__bmOA9G__folderTree",
  "header": "AssetLayout-module__bmOA9G__header",
  "layout": "AssetLayout-module__bmOA9G__layout",
  "mobileNav": "AssetLayout-module__bmOA9G__mobileNav",
  "resizeHandle": "AssetLayout-module__bmOA9G__resizeHandle",
  "searchContainer": "AssetLayout-module__bmOA9G__searchContainer",
  "sidebar": "AssetLayout-module__bmOA9G__sidebar",
});
